module.exports = __webpack_public_path__ + "static/dd-madde4-65062f75d3102560726cc2dbf08b4bea.png";